import { AsyncPipe } from '@angular/common';
import { httpResource } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../environments/environment';
import { EventsNextComponent } from '../../modules/event';
import { FeatureDynamicService } from '../../modules/feature-dynamic';
import { NewsNextComponent } from '../../modules/news';
import { WeatherComponent } from '../../modules/weather';
import { BreakpointService } from '../../services/breakpoint.service';
import { CurrentRouteService } from '../../services/current-route.service';
import { EventService } from '../../services/event.service';
import { WeatherService } from '../../services/weather.service';
import { INewsArticleListResponseDto } from '../../shared/ystm-service-api-types';
import { SponsorsComponent } from '../sponsors/sponsors.component';
import { DonationComponent } from '../../modules/donation';
import { SommerfestTeaserComponent } from '../../modules/sommerfest/sommerfest-teaser/sommerfest-teaser.component';

@Component({
    selector: 'app-application-info-panel',
    imports: [
        AsyncPipe,
        MatButtonModule,
        EventsNextComponent,
        NewsNextComponent,
        WeatherComponent,
        DonationComponent,
        SponsorsComponent,
        SommerfestTeaserComponent
    ],
    templateUrl: './application-info-panel.component.html',
    styleUrl: './application-info-panel.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationInfoPanelComponent {
  readonly breakpointService = inject(BreakpointService);
  readonly currentRouteService = inject(CurrentRouteService);
  readonly eventService = inject(EventService);
  readonly weatherService = inject(WeatherService);
  readonly featureDynamicService = inject(FeatureDynamicService);

  newsResource = httpResource(
    () => ({
      url: `${environment.ystmServiceBaseUrl}/news/public`,
    }),
    { parse: (res: unknown) => (res as INewsArticleListResponseDto) || { newsArticles: [] } }
  );
}
